import React, { Component } from 'react';
import { connect } from "react-redux";
import PropTypes from 'prop-types';
import { Card, CardHeader, CardFooter, CardBody, Row, Col } from 'reactstrap';
import { metadataService } from "../../_services";
import { SlBranchDisplay, SlBusyIndicator, SLDetailsTable } from "../editors";
import GuestLeadDocuments from './GuestLeadDocuments';

class GuestLeadInfoView extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isWorking: false,
        };
    }

    getLeadDescription(lead) {
        switch (lead.leadType) {
            case 7:
                return metadataService.getLabel("RefinanceLoanRequest");
            case 8:
                return metadataService.getLabel("IncreaseLoanRequest");
            default:
                return metadataService.getLabel("NewLoanRequest");
        }
    }

    render() {
        const { lead, showDocumentsNeeded } = this.props;
        const { isWorking } = this.state;

        return (
            <div>
                <Card className="lead-info-view-card pl-0 ml-0">
                    <CardHeader className="bg-primary ">
                        <b>{this.getLeadDescription(lead)}</b>
                    </CardHeader>
                    <SlBusyIndicator visible={isWorking} />
                    {isWorking === false && (
                        <div>
                            {lead.status === 5 && !showDocumentsNeeded && (
                                <CardFooter>
                                    <Row>
                                        <Col>
                                            <div className="lead-info-application-status">
                                                {metadataService.getLabel("ApplicationInProcess")}
                                            </div>
                                        </Col>
                                    </Row>
                                    <br />
                                    <Row>
                                        <Col sm="2"></Col>
                                        <Col sm="8">
                                            <div>
                                                {metadataService.getMessage("OneOfOurRepresentatives")}
                                            </div>
                                        </Col>
                                        <Col sm="2"></Col>
                                    </Row>
                                </CardFooter>
                            )}

                            {showDocumentsNeeded && (
                                <CardBody>
                                    <GuestLeadDocuments leadId={lead.leadId} documents={lead.documents} />
                                </CardBody>
                            )}

                            <CardBody>
                                <Row>
                                    <Col>
                                        <SLDetailsTable
                                            dataSource={[
                                                {
                                                    label: metadataService.getFieldNameLabel("RequestDate"),
                                                    value: metadataService.formatDateString(lead.timestamp),
                                                },
                                                {
                                                    label: metadataService.getFieldNameLabel("Status"),
                                                    value: metadataService.getLookupText("leadStatus", lead.status),
                                                },
                                            ]}
                                        />
                                    </Col>
                                </Row>
                            </CardBody>
                        </div>
                    )}
                </Card>
            </div>
        );
    }
}

GuestLeadInfoView.propTypes = {
    lead: PropTypes.object.isRequired,
    showDocumentsNeeded: PropTypes.bool
}

const mapStateToProps = (state) => {
    const { language } = state.users;
    return { language };
};

const connectedGuestLeadInfoView = connect(mapStateToProps)(GuestLeadInfoView);
export { connectedGuestLeadInfoView as GuestLeadInfoView };
